import React from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import "./attachmentConfirmationStyle.scss";

interface AttachmentConfirmationModalProps {
  showModal: boolean;
  handleCloseModal: () => void;
  handleConfirm: () => void;
  isLoading?: boolean;
  message?: string;
}

const AttachmentConfirmationModal: React.FC<
  AttachmentConfirmationModalProps
> = ({
  showModal,
  handleCloseModal,
  handleConfirm,
  isLoading = false,
  message,
}) => {
  return (
    <Dialog
      header={
        <div className="flex justify-content-between align-items-center">
          <span className="model-head">
            Are you sure you want to upload this file?
          </span>
        </div>
      }
      visible={showModal}
      onHide={handleCloseModal}
      className="confirmation-content"
    >
      <div className="confirmation-description">
        <span>
          {message
            ? message
            : "Please double-check that you are uploading the correct document. Do not share private or personal information in the wrong entity process or with the wrong recipient."}
        </span>
      </div>
      <div className="flex justify-content-end gap-2 pt-4">
        <Button
          label="Cancel"
          className="cancel-btn"
          outlined
          onClick={handleCloseModal}
        />
        <Button
          label="Yes, Confirm"
          loading={isLoading}
          className="proceed-btn flex flex-row-reverse"
          onClick={handleConfirm}
        />
      </div>
    </Dialog>
  );
};

export default AttachmentConfirmationModal;
